import AppStoreLogo from "@/components/data-display/logo/AppStore";
import PlayStoreLogo from "@/components/data-display/logo/PlayStore";
import { MOBILE_APP_LINK } from "@/utils/constants/mobileAppLink";
import Image from "next/image";
import React from "react";

const AppDownloadPage = () => {
  return (
    <div className="flex flex-col md:flex-row lg:justify-between items-center mt-[4rem] md:py-[3rem] lg:py-0 gap-[3rem] md:gap-[7.5rem] pl-[1.25rem] md:pl-[4rem] lg:pl-[7.5rem] ">
      <div className="rounded-md max-w-[36rem]">
        <h1 className="text-[1.5rem] md:text-[2rem]  lg:text-[2.75rem] font-semibold mb-4">
          The App That Makes Taking Care of Your Pets Easier!
        </h1>
        <p className="">
          Your pets deserve all the best foods and accessories. Download the
          AmarPet app and enjoy all our special services! AmarPet app is
          available on both iOS and Android. Download now!
        </p>
        <div className="flex space-x-4 mt-[3rem]">
          <AppStoreLogo redirectUrl={MOBILE_APP_LINK.app_store} />
          <PlayStoreLogo redirectUrl={MOBILE_APP_LINK.play_store} />
        </div>
      </div>

      <div>
        <Image
          src="/assets/app-download-image.jpg"
          height={688}
          width={700}
          alt="app-download-page"
        />
      </div>
    </div>
  );
};

export default AppDownloadPage;
